<app-configuration-page
  title="Import Packages"
  description="Bring lesson packages into the studio from a spreadsheet."
  [breadcrumbs]="[{ label: 'Simple Import' }, { label: 'Import Packages' }]">

  <app-simple-import-packages></app-simple-import-packages>

</app-configuration-page>
